import $ from "jquery";
import debounce from "lodash.debounce";

export const MOBILE_STATE_MODIFIER = "mobile-on";
export const DESKTOP_STATE_MODIFIER = "mobile-off";

const DESKTOP_BREAKPOINT = 992 - 15;
const SIDE_FILTERS_BREAKPOINT = DESKTOP_BREAKPOINT;

export function isDesktop() {
  return document.body.classList.contains(DESKTOP_STATE_MODIFIER);
}

export function isMobileSize() {
  return $(window).width() < DESKTOP_BREAKPOINT;
}

export function onPageResize(callback, debounceTime) {
  if (debounceTime) {
    $(window).resize(debounce(callback, debounceTime));
  } else {
    $(window).resize(callback);
  }
}

export class ResponsiveWindow {
  constructor(nav) {
    this._nav = nav;
    this._filters = [];
    this._body = jQuery("body");
    this._currentWidth = 0;
    this._onPageLoad(this.resize.bind(this));
    this._onPageResize(this.resize.bind(this), 20);
  }

  addFilters() {
    this._filters = this._filters.concat(...arguments);

    // Ensure resize occurs after adding new filter
    this._currentWidth = 0;
  }

  resize() {
    const newWidth = jQuery(window).width();

    if (newWidth === this._currentWidth) {
      return;
    }

    this._currentWidth = newWidth;

    if (newWidth >= DESKTOP_BREAKPOINT) {
      this._body.removeClass(MOBILE_STATE_MODIFIER).addClass(DESKTOP_STATE_MODIFIER);
      this._nav.becomeDesktop();
    } else {
      this._body.addClass(MOBILE_STATE_MODIFIER).removeClass(DESKTOP_STATE_MODIFIER);
      this._nav.becomeMobile();
    }

    if (newWidth >= SIDE_FILTERS_BREAKPOINT) {
      this._filters.forEach((filter) => {
        filter.becomeDesktop();
      });
    } else {
      this._filters.forEach((filter) => {
        filter.becomeMobile();
      });
    }
  }

  _onPageLoad(callback) {
    jQuery(document).ready(callback);
  }

  _onPageResize(callback, debounceTime) {
    onPageResize(callback, debounceTime);
  }
}
